import {
  Input as RSInput
} from 'reactstrap'
import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 30px;
  text-align: left;
  margin: auto;
  width: 100%;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Input = styled(RSInput)`
  padding-top: 32px;
  padding-bottom: 32px;
  padding-left: 22px;
  color: black;
  width: 100%;
  margin-right: auto;
  margin-top: 12px;
  border-radius: 12px;
  border: 2px solid #ccd6e0;
  font-size: 40px;
  min-height: 100px;
`;

export const CheckboxListContainer = styled.div`
  display: flex;
  // justify-content: space-between; /* Alinha o primeiro item à esquerda e o segundo à direita */
  flex-wrap: wrap; /* Permite que os checkboxes quebrem de linha se necessário */
  gap: 20px; /* Espaçamento entre os checkboxes */
`;


export const CheckboxContainer = styled.label<{ color: string; fontSize: number }>`
  color: ${(props) => (props.color ? props.color : 'black')};
  display: flex;
  align-items: center;
  gap: 10px; /* Espaçamento entre o checkbox e o rótulo */
  font-size: ${(props) => (props.fontSize ? props.fontSize + 'px' : '20px')};

  /* Estilos para o checkbox */
  input[type='checkbox'] {
    width: 40px; /* Largura desejada da caixa do checkbox */
    height: 40px; /* Altura desejada da caixa do checkbox */
    margin: 0; /* Remova as margens padrão */
  }
`;


export const CheckboxContainerRow = styled.div`
  display: flex;
  align-items: center;
`;


export const ButtonContainer = styled.div<{ color: string, fontSize: number }>`  
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const Label = styled.label<{ color: string, fontSize: number }>`
  color: ${(props) => (props.color ? props.color : '#FFFFFF')};
  margin-bottom: 6px;
  width: auto;
  margin-right: auto;
  font-size: ${(props) => (props.fontSize ? props.fontSize + 'px' : '36px')};
  font-weight: 700;
  padding-top: 14px;
  text-shadow: 0 1px 3px rgba(0,0,0,0.25);
`;

export const ErrorLabel = styled.label`
  color: red;
  margin-top: 7px;
  margin-left: 16px;
  font-size: 20px;
`;

export const ObservationLabel = styled.label`
  color: white;
  margin-top: 10px;
  font-size: 14px;
  margin: auto;
  padding-top: 10px;
`;

export const Button = styled.button`
  background-color: white;
  color: black;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 300px;
  margin: auto;
  margin-top: 120px;
  font-size: 20px;
  font-weight: bold;
  border-radius: 5px;
`;

export const ButtonCheck = styled.button<{ color: string, fontSize: number, isSelected: boolean }>`
  background-color: ${(props) => (props.isSelected ? '#d4ab6e' : 'white')};
  color: ${(props) => (props.color ? props.color : 'black')};
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  margin: auto;
  margin-top: 15px;
  margin-right: 5px;
  font-size: ${(props) => (props.fontSize ? props.fontSize + 'px' : '20px')};
  font-weight: bold;
  border-radius: 5px;
  width: 52px;
  text-align: center;
`;

export const ButtonLogoff = styled.button`
  background-color: white;
  color: black;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  width: 80px;
  margin: auto;
  margin-bottom: 10px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 5px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
`